<script setup lang="ts">
withDefaults(
  defineProps<{
    avatarSrc?: string
    initials?: string
    name: string
    email: string
  }>(),
  { avatarSrc: undefined, initials: undefined },
)
</script>

<template>
  <div class="flex flex-col items-center gap-2 py-4">
    <UAvatar :src="avatarSrc" :text="initials" :alt="name" size="3xl" />
    <div class="text-center">
      <div class="text-highlighted text-lg font-semibold">{{ name }}</div>
      <div class="text-muted text-sm">{{ email }}</div>
    </div>
    <slot />
  </div>
</template>
